/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Text_SubmenuInputs */



/**
* | output |
* | --- |
* | "Text formatting submenu" |
*
* @param {Text_SubmenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text_submenu = /** @type {((inputs?: Text_SubmenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Text_SubmenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-menu de formatage du texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untermenü „Textformatierung“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottomenu di formattazione del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подменю форматирования текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Submenú de formato de texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本格式子菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト書式設定サブメニュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट फ़ॉर्मेटिंग सबमेनू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Submenu de formatação de texto")
	return /** @type {LocalizedString} */ ("Text formatting submenu")
});